export const COLORS = {
    hover_gray: '#E7E6F6',
    white: '#FFFFFF',
    disabled: '#CCC',
    secondary: '#1E156A',
    primary: '#432EEA',
    error: '#F62437',
};

export enum UI_MODE {
    ADMIN = 'admin',
    OUTBOUND = 'outbound',
    OUTBOUND_V2 = 'outbound_v2',
    OMNI = 'omni',
    TALK_V2 = 'talk_v2',
    MOBILE = 'mobile',
    EXTERNAL = 'external',
    VIRTUAL_AGENT = 'virtual_agent',
}

export enum CER_IDS {
    BUSY = 7,
}

export enum DATATABLE {
    CONTACT_COMMENT_HISTORY = 'contact_comment_history',
}

export const TRACKER_INTERVAL = {
    robot: 60,
    queue_length: 10,
    activities_data: 60,
    inbound_ban: 60,
    min_sec_session_update: 60,
    max_sec_session_update: 180,
};

export enum ASTERISK_ORIGINATE_REASONS {
    RINGING = '3',
    BUSY = '5',
    CONGESTION = '8',
}

/** Default values for various feature flags and settings */
export const SETTING_DEFAULTS: Record<string, any> = {
    /** Same as `Utils::SETTING_CURRENCY_DECIMAL_COUNT_DEFAULT` in the backend */
    currency_decimal_count: 3,
};
